import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2ReviewStatusHistory } from '@/api/model/interfaces';

export default class PackageKS2ReviewStatusHistoryOdata extends OdataManager<PackageKS2ReviewStatusHistory> {}
